import { useMutation } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { reportError } from 'utils/error'
import { buildErrorMessage } from 'utils'
import { UseMutationOptions } from 'react-query/types/react/types'
import { RegistrationData, UserClient } from 'api/clients/UserClient'

type Variables = {
  signupReason?: string
  businessType?: string
  useCases?: string[]
  discoverySource?: string
  teamSize?: string
  trialRequired?: boolean
  demoRequired?: boolean
  trialOrDemoRequired?: boolean
  utm_campaign?: string | null
  utm_content?: string | null
  utm_medium?: string | null
  utm_source?: string | null
  utm_term?: string | null
  referral_page?: string | null
  referrer?: string | null
  marketingExperienceLevel?: number
  contentCreationCategory?: string
  contentCreationSubcategory?: string
}

interface Data {
  user_registration_data: RegistrationData
}

export type Options = Omit<UseMutationOptions<Data, unknown, Variables>, 'mutationKey' | 'mutationFn'>

export const useUpdateRegistrationData = (options?: Options) =>
  useMutation<Data, unknown, Variables>(
    ['updateRegistrationData'],
    async (variables) => {
      const response = await UserClient.registrationData(variables)

      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        reportError('Failed to update registration data', {
          metaData: {
            response: response.data,
          },
        })
        throw new Error(
          buildErrorMessage(response.data.errors) ||
            'An error occurred! Our team has been notified and we are looking into it.',
        )
      }

      return response.data
    },
    {
      ...options,
    },
  )
